import {
  ApiSlugs,
  EntityStateDto,
  IdentityVerificationStatus,
  PatchEntityStateDto,
  StripeVerificationSessionSummaryDto,
  UserForAdminDto,
  UserId,
  UserRoleRepresentationDto,
  UserRolesRepresentationDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../api-caller.service';
import { ApiConnector } from '../../../../api-connector.abstract-service';
import { UserEmailsAdminConnector } from './emails/user-emails.connector';
import { UserFilesAdminConnector } from './files/user-emails.connector';
import { UserHistoryAdminConnector } from './history/user-history.connector';
import { UserNotificationsAdminConnector } from './notifications/user-notifications.connector';
import { UserSessionsAdminConnector } from './sessions/user-sessions.connector';
import { UserSMSAdminConnector } from './sms/user-sms.connector';
import { UserSubscriptionsAdminConnector } from './subscriptions/user-subscriptions.connector';
import { UserTicketsAdminConnector } from './tickets/user-tickets.connector';
import { UserTokenVaultsAdminConnector } from './token-vaults/user-token-vaults.connector';
import { UserTransactionsAdminConnector } from './transactions/user-transactions.connector';

export class UserAdminConnector extends ApiConnector<UserForAdminDto, UserForAdminDto, UserId> {
  constructor(apiCaller: ApiCaller, userId: UserId, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${ApiSlugs.USER}/${userId}`);
  }

  emails = () => new UserEmailsAdminConnector(this.apiCaller, this.slug, this.apiPrefix);
  sms = () => new UserSMSAdminConnector(this.apiCaller, this.slug, this.apiPrefix);
  notifications = () => new UserNotificationsAdminConnector(this.apiCaller, this.slug, this.apiPrefix);
  tickets = () => new UserTicketsAdminConnector(this.apiCaller, this.slug, this.apiPrefix);
  tokenVaults = () => new UserTokenVaultsAdminConnector(this.apiCaller, this.slug, this.apiPrefix);
  sessions = () => new UserSessionsAdminConnector(this.apiCaller, this.slug, this.apiPrefix);

  files = () => new UserFilesAdminConnector(this.apiCaller, this.slug, this.apiPrefix);
  history = () => new UserHistoryAdminConnector(this.apiCaller, this.slug, this.apiPrefix);
  subscriptions = () => new UserSubscriptionsAdminConnector(this.apiCaller, this.slug, this.apiPrefix);
  transactions = () => new UserTransactionsAdminConnector(this.apiCaller, this.slug, this.apiPrefix);

  latestStripeVerificationSession = (): Observable<StripeVerificationSessionSummaryDto> =>
    this.apiCaller.getRequest(this.apiPrefix, `${this.slug}/latest-stripe-verification-session`);

  patch = () => ({
    state: (state: PatchEntityStateDto): Observable<EntityStateDto> =>
      this.apiCaller.patchRequest(this.apiPrefix, `${this.slug}/state`, state),
    roles: (roles: UserRolesRepresentationDto): Observable<UserRoleRepresentationDto[]> =>
      this.apiCaller.patchRequest(this.apiPrefix, `${this.slug}/roles`, roles),
    verificationStatus: (
      status: IdentityVerificationStatus,
      applyIdentityData = false,
    ): Observable<UserForAdminDto> =>
      this.apiCaller.patchRequest(this.apiPrefix, `${this.slug}/verification-status`, {
        status,
        applyIdentityData,
      }),
  });

  impersonate = () => this.apiCaller.postRequest(this.apiPrefix, `${this.slug}/impersonate`);
}
